import * as React from 'react';
import { connect } from 'react-redux';
import PowerBiViewController from './PowerBiViewController';
import { IPbiReport, IPbiDataset } from './business-objects/types';
import PowerBiCreateReport from './PowerBiCreateReport';
import * as urls from '../shared/urls';

import { SaveNewReport, GetDatasets } from './redux-objects/actions';
import SelectList from '../RBSelectList/RBSelectList';
import { Form, Row, Col } from 'react-bootstrap';

export interface ICreatePbiReportProps {
  GetDatasets?: (url: string) => Promise<void>;
  datasets: IPbiDataset[];
}

interface ICreatePbiReportState {
  selectedDatasetId: string;
}

class CreatePbiReport extends React.Component<
  ICreatePbiReportProps,
  ICreatePbiReportState
> {
  constructor(props: ICreatePbiReportProps) {
    super(props);
    this.state = { selectedDatasetId: null };
  }

  componentDidMount() {
    this.props.GetDatasets(urls.POWERBI_GET_DATASETS).then(() => {
      this.setState({ selectedDatasetId: this.props.datasets[0].id });
    });
  }

  handleChange = (e: React.FormEvent) => {
    let el: HTMLFormElement = e.currentTarget as HTMLFormElement;

    switch (el.dataset.field) {
      case 'dataset':
        this.setState({
          selectedDatasetId: el.value,
        });
      default:
        break;
    }
  };

  public render() {
    return (
      <div>
        <Form>
          <Row>
            <Col>
              <h2>Create Report</h2>
            </Col>
            <Col>
              <Form.Group as={Row} controlId='formPlaintextEmail'>
                <Form.Label column sm='4'>
                  Dataset:
                </Form.Label>
                <Col sm='6'>
                  {this.props.datasets && this.state.selectedDatasetId && (
                    <SelectList
                      onChange={this.handleChange}
                      datafield='dataset'
                      data={this.props.datasets.map((x) => {
                        return { name: x.name, value: x.id };
                      })}
                      value={this.state.selectedDatasetId}
                    />
                  )}
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              {this.state.selectedDatasetId &&
                this.state.selectedDatasetId.length > 0 && (
                  <PowerBiCreateReport
                    datasetId={this.state.selectedDatasetId}
                  />
                )}
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}

export function mapStateToProps(state: any) {
  return {
    datasets: state.PowerBI.datasets,
  };
}

const mapDispatchToProps = {
  GetDatasets,
};

export default connect(mapStateToProps, mapDispatchToProps)(CreatePbiReport);
